import { useEffect, useState } from 'react';

import { Util } from '@finley-technologies/finley-types';

import {
  AssignmentPreviewJobFragmentGQLType,
  AssignmentConfirmationJobFragmentGQLType,
  useGetAssignmentJobsQuery,
} from 'types/dashboard-core-gqlTypes.generated.d';

export const usePollAssignmentJobs = ({
  reportingDate,
  fileVersion,
  implementationId,
}: {
  reportingDate?: Util.FullDateStr;
  fileVersion?: number;
  implementationId: string;
}) => {
  const [previewJobs, setPreviewJobs] = useState<
    AssignmentPreviewJobFragmentGQLType[]
  >();

  const [
    latestAssignmentConfirmationJob,
    setLatestAssignmentConfirmationJob,
  ] = useState<AssignmentConfirmationJobFragmentGQLType | null>();

  const { data, startPolling, stopPolling } = useGetAssignmentJobsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      implementationId,
      reportingDate,
      fileVersion,
    },
  });

  useEffect(() => {
    startPolling(5000);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  useEffect(() => {
    setPreviewJobs(data?.assignmentJobs?.previewJobs ?? []);
    setLatestAssignmentConfirmationJob(
      data?.assignmentJobs?.latestConfirmationJob,
    );
  }, [data]);

  return {
    latestAssignmentConfirmationJob,
    previewJobs,
  };
};
